import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  formatDateFromEpoch,
  getSingleDateIfEqual,
  formatDateFromEpochWith3MonthLetters,
  toSingleDateStringIfEqual,
  serverFormatToDateString,
  formatDateTimeRangeFromServer,
} from "../../../system";
import activitySpotIcon from "../../../assets/images/icon/activity_spot_icon.svg";
import activityCalendarIcon from "../../../assets/images/icon/activity_calendar_icon.svg";
import timeCalendarIcon from "../../../assets/images/icon/calender_time_icon.svg";
import {
  Directions,
  calenderConstants,
  eventConstants,
  translationConstants,
  viewPathConstants,
  DateFormatType,
  timezoneConstants,
} from "../../../constants";
import logoPlaceholder from "../../../assets/images/logo/activityLogoPlaceholder.png";
import competitionAgeIcon from "../../../assets/images/icon/wind-turbine-2.svg";
import {
  centerActivityActions,
  competitionActions,
} from "../../../redux/actions";
import { useNavigate } from "react-router-dom";
import StopPropagation from "../StopPropagation/StopPropagation";
import ServerFormatToDate from "../FormatDate/ServerFormatToDate";

const CalenderCard = ({ activity, flag }) => {
  const { t } = useTranslation();

  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });

  const cities = useSelector((state) => state.LoginReducer.cities);
  const city = cities.find((city) => city.id === activity?.eventCityId);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewDetailClick = () => {
    if (activity?.type == calenderConstants.COMPETITION_TYPE) {
      dispatch(competitionActions.getPublicCompetitionById(activity?.guidId));
      navigate(`${viewPathConstants.PUBLIC_COMPETITIONS_DETAIL}`, {
        state: {
          flag: flag == 0 ? "upcoming" : "previous",
          competitionId: activity?.guidId,
        },
      });
    }
    if (activity?.type == calenderConstants.EVENT_TYPE) {
      navigate(
        `${viewPathConstants.VIEW_EVENT_DETAIL}?${eventConstants.EVENT_ID}=${activity?.guidId}`,
        {
          state: {
            eventId: activity?.guidId,
            isActive: true,
          },
        }
      );
    }
    if (activity?.type == calenderConstants.CENTER_TYPE) {
      dispatch(centerActivityActions.getActivityById(activity.longId));
    }
  };

  const isMobile = useSelector((state) => {
    return state.systemReducer.isMobile;
  });

  return (
    <div className="d-flex col-md-12 py-2">
      <div
        className={`
          ${
            activity?.type == calenderConstants.EVENT_TYPE && "event-type-head"
          } 
          ${
            activity?.type == calenderConstants.COMPETITION_TYPE &&
            "competition-type-head"
          } 
          ${
            activity?.type == calenderConstants.CENTER_TYPE &&
            "activity-type-head"
          } 
        
        px-1 ${
          direction == Directions.ltr
            ? "right-border-radius"
            : "left-border-radius"
        }`}
      >
        <div
          className={`${direction == Directions.rtl ? "event-type-text" : ""}`}
        >
          {activity?.type == calenderConstants.EVENT_TYPE &&
            t(translationConstants.EVENT)}
          {activity?.type == calenderConstants.COMPETITION_TYPE &&
            t(translationConstants.COMPETITION)}
          {activity?.type == calenderConstants.CENTER_TYPE &&
            t(translationConstants.ACTIVITY)}
        </div>
      </div>
      <div
        className={`activity-card ps-lg-0 cast-shadow-on-hover overflow-hidden w-100 ${
          direction == Directions.ltr
            ? "remove-borders-left"
            : "remove-borders-right"
        }`}
        onClick={() => {
          handleViewDetailClick();
        }}
      >
        <div className="row m-0 gap-3 gap-md-0">
          <div className="col-md-1 col-lg-1 d-none d-md-none d-lg-block d-flex justify-content-md-center align-items-md-center px-1 text-md-center">
            <span className="activity-date" dir={Directions.ltr}>
              <ServerFormatToDate dateString={activity?.startDateString} />
            </span>
          </div>
          <div className="col-md-9 px-md-4 px-0 activity-card-content-wrapper">
            <div className="d-flex gap-3">
              <div
                className={`activity-card-image-wrapper col-5 col-md-1 ${
                  isMobile ? "h-100" : "h-100 width-100px"
                }`}
              >
                <img
                  src={
                    activity?.logo?.link
                      ? activity?.logo?.link
                      : logoPlaceholder
                  }
                  alt="activity"
                />
              </div>
              <div className="col-7 col-md-5 col-lg-5 px-md-2 d-flex flex-column justify-content-between">
                <div>
                  <div className="d-flex flex-column">
                    <h5
                      className={`fw-800 text-ellipsis m-0 ${
                        direction === Directions.rtl ? "text-end" : "text-start"
                      }`}
                    >
                      {direction === Directions.rtl && activity?.arabicTitle
                        ? `${activity?.arabicTitle}`
                        : `${activity?.title}`}
                    </h5>
                  </div>
                  {activity?.type === "CenterActivity" && (
                    <div className="d-none d-md-flex font-16 text-green">
                      {activity?.centerName}
                    </div>
                  )}
                  {activity?.type === calenderConstants.COMPETITION_TYPE &&
                    activity?.spotName && (
                      <div className="d-none d-md-flex font-16 text-green">
                        {activity?.spotName}
                      </div>
                    )}
                </div>
                <div className="contact-information-card-wrapper">
                  <div className="d-flex gap-1 flex-column">
                    <div className="contact-information-card pt-0">
                      <img alt="" name="activitySpot" src={activitySpotIcon} />
                      <span className="font-14">
                        {activity?.spotName}
                        {activity?.spotName && activity?.eventCityId && ","}
                        {direction === Directions.rtl && activity?.eventCityId
                          ? city?.arabicName || city?.name
                          : city?.name}
                      </span>
                    </div>
                    <div className="contact-information-card">
                      <img
                        alt=""
                        name="activityDate"
                        src={activityCalendarIcon}
                      />
                      <span
                        className={`${isMobile ? "font-12" : "font-14"} ${
                          direction === Directions.rtl
                            ? "text-end"
                            : "text-start"
                        }`}
                      >
                        {toSingleDateStringIfEqual(
                          activity?.startDateString,
                          activity?.endDateString
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column flex-sm-row gap-1 mt-1 d-block d-md-none">
                    {activity?.minAge && activity?.maxAge && (
                      <div className="d-lg-flex ">
                        <div className="contact-information-card pt-1 me-lg-4">
                          <img
                            alt=""
                            name="activityDate"
                            src={competitionAgeIcon}
                          />
                          <span
                            className={`${isMobile ? "font-12" : "font-14"}`}
                          >{` ${activity?.minAge} - ${activity?.maxAge} ${t(
                            translationConstants.YEARS
                          )}`}</span>
                        </div>
                      </div>
                    )}
                    <div className="contact-information-card pt-lg-2">
                      <img alt="" name="activityDate" src={timeCalendarIcon} />
                      <span className={`${isMobile ? "font-12" : "font-14"}`}>
                        {formatDateTimeRangeFromServer(
                          activity?.startDateString,
                          activity?.endDateString,
                          timezoneConstants.hourMinuteFormat
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-end d-none d-md-flex gap-2">
                {activity?.minAge && activity?.maxAge && (
                  <div className="d-lg-flex ">
                    <div className="contact-information-card pt-1">
                      <img
                        alt=""
                        name="activityDate"
                        src={competitionAgeIcon}
                      />
                      <span className="font-14">{` ${activity?.minAge} - ${
                        activity?.maxAge
                      } ${t(translationConstants.YEARS)}`}</span>
                    </div>
                  </div>
                )}
                <div className="contact-information-card pt-lg-2">
                  <img alt="" name="activityDate" src={timeCalendarIcon} />
                  <span className="font-14">
                    {formatDateTimeRangeFromServer(
                      activity?.startDateString,
                      activity?.endDateString,
                      timezoneConstants.hourMinuteFormat
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalenderCard;
